export var mobileDevice = function mobileDevice(siteApi) {
  return {
    index: function index(orderBy) {
      return siteApi.get('/mobile-device', {
        params: {
          includeInmates: true,
          orderBy: orderBy,
          applications: 'Connect - Messaging',
          perPage: 1000
        }
      });
    },
    getAvailable: function getAvailable() {
      return siteApi.get('/mobile-device', {
        params: {
          excludeInmateAssigned: true,
          orderBy: 'name',
          applications: 'Connect - Messaging',
          perPage: 1000
        }
      });
    },
    resetAppLock: function resetAppLock(ids) {
      return siteApi.put("/mobile-device/".concat(ids.join(','), "/reset-app-lock"));
    },
    put: function put(ids, data) {
      return siteApi.put("/mobile-device/".concat(ids.join(',')), data);
    },
    group: {
      index: function index(params) {
        if (params === void 0) {
          params = {};
        }
        return siteApi.get('/mobile-device/group', {
          params: params
        });
      }
    }
  };
};